import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.css';
import './assets/css/main.css'; 
import { Tooltip } from 'bootstrap'
import AOS from 'aos'
import 'aos/dist/aos.css'


const app = createApp(App).use(store).use(router)
app.mount('#app')

// Initialize AOS
AOS.init({
  duration: 800,
  easing: 'ease-in-out',
  once: true,
  offset: 100,
  delay: 100
})

// Initialize tooltips after mount and on route changes
let tooltipInstances = []
function initTooltips() {
  // Dispose previous instances to avoid duplicates
  tooltipInstances.forEach(t => t.dispose())
  tooltipInstances = []
  const triggers = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  triggers.forEach(el => tooltipInstances.push(new Tooltip(el)))
}

initTooltips()
router.afterEach(() => {
  // Wait next tick for DOM to update
  setTimeout(() => {
    initTooltips()
    AOS.refresh() // Refresh AOS on route change
  }, 0)
})